export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/greenRightArrow.017d895f.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};